var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTadaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.015 32.237a12.03 12.03 0 00-8.497 3.514 1.653 1.653 0 01-2.336-2.34 15.336 15.336 0 0121.666 0 1.653 1.653 0 11-2.335 2.34 12.03 12.03 0 00-8.498-3.514z",
    fill: "url(#tada-icon_svg__paint0_linear_3870_53127)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.193 1.138a1.653 1.653 0 012.338-.001 15.32 15.32 0 010 21.671 1.653 1.653 0 01-2.338-2.338 12.014 12.014 0 000-16.994 1.653 1.653 0 010-2.338z",
    fill: "url(#tada-icon_svg__paint1_linear_3870_53127)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.97 19.913a1.653 1.653 0 01-1.046 2.091l-9.666 3.218a1.653 1.653 0 11-1.044-3.138l9.666-3.217a1.653 1.653 0 012.09 1.046z",
    fill: "url(#tada-icon_svg__paint2_linear_3870_53127)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.039 5.977a1.653 1.653 0 011.045 2.092l-3.223 9.669a1.653 1.653 0 11-3.137-1.046l3.224-9.67a1.653 1.653 0 012.09-1.045z",
    fill: "url(#tada-icon_svg__paint3_linear_3870_53127)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.232 14.072c0-.913.74-1.653 1.654-1.653a2.342 2.342 0 012.341 2.341 1.653 1.653 0 01-3.114.774 1.653 1.653 0 01-.88-1.462z",
    fill: "url(#tada-icon_svg__paint4_linear_3870_53127)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.659 15.534a1.653 1.653 0 00-.773-3.115 2.342 2.342 0 00-2.342 2.341 1.653 1.653 0 003.115.774z",
    fill: "url(#tada-icon_svg__paint5_linear_3870_53127)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.659 13.988a1.653 1.653 0 00-3.115.773 2.342 2.342 0 002.342 2.341 1.653 1.653 0 00.773-3.114z",
    fill: "url(#tada-icon_svg__paint6_linear_3870_53127)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.574 13.107c.913 0 1.653.74 1.653 1.654a2.342 2.342 0 01-2.341 2.341 1.653 1.653 0 01-.773-3.114c.277-.524.828-.88 1.461-.88z",
    fill: "url(#tada-icon_svg__paint7_linear_3870_53127)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.893 22.336c0-.913.74-1.653 1.653-1.653a2.342 2.342 0 012.342 2.342 1.653 1.653 0 01-3.115.773 1.653 1.653 0 01-.88-1.462z",
    fill: "url(#tada-icon_svg__paint8_linear_3870_53127)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.32 23.798a1.653 1.653 0 00-.774-3.115 2.342 2.342 0 00-2.342 2.342 1.653 1.653 0 003.115.773z",
    fill: "url(#tada-icon_svg__paint9_linear_3870_53127)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.32 22.252a1.653 1.653 0 00-3.116.773 2.342 2.342 0 002.342 2.342 1.653 1.653 0 00.773-3.115z",
    fill: "url(#tada-icon_svg__paint10_linear_3870_53127)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.235 21.372c.913 0 1.653.74 1.653 1.653a2.342 2.342 0 01-2.342 2.342 1.653 1.653 0 01-.773-3.115c.278-.524.828-.88 1.462-.88z",
    fill: "url(#tada-icon_svg__paint11_linear_3870_53127)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.912 38.865c0-.913.74-1.654 1.653-1.654a2.342 2.342 0 012.342 2.342 1.653 1.653 0 01-3.115.773 1.653 1.653 0 01-.88-1.461z",
    fill: "url(#tada-icon_svg__paint12_linear_3870_53127)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.338 40.326a1.653 1.653 0 00-.773-3.115 2.342 2.342 0 00-2.342 2.342 1.653 1.653 0 003.115.773z",
    fill: "url(#tada-icon_svg__paint13_linear_3870_53127)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.338 38.78a1.653 1.653 0 00-3.115.773 2.342 2.342 0 002.342 2.342 1.653 1.653 0 00.773-3.115z",
    fill: "url(#tada-icon_svg__paint14_linear_3870_53127)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.254 37.9c.913 0 1.653.74 1.653 1.653a2.342 2.342 0 01-2.342 2.342 1.653 1.653 0 01-.773-3.115c.278-.523.828-.88 1.462-.88z",
    fill: "url(#tada-icon_svg__paint15_linear_3870_53127)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.29 11.317c0-.913.74-1.653 1.653-1.653a2.342 2.342 0 012.342 2.342 1.653 1.653 0 01-3.115.773 1.653 1.653 0 01-.88-1.462z",
    fill: "url(#tada-icon_svg__paint16_linear_3870_53127)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.716 12.779a1.653 1.653 0 00-.773-3.115 2.342 2.342 0 00-2.342 2.342 1.653 1.653 0 003.115.773z",
    fill: "url(#tada-icon_svg__paint17_linear_3870_53127)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.716 11.233a1.653 1.653 0 00-3.115.773 2.342 2.342 0 002.342 2.342 1.653 1.653 0 00.773-3.115z",
    fill: "url(#tada-icon_svg__paint18_linear_3870_53127)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.631 10.352c.913 0 1.654.74 1.654 1.654a2.342 2.342 0 01-2.342 2.342 1.653 1.653 0 01-.773-3.115c.277-.524.828-.88 1.461-.88z",
    fill: "url(#tada-icon_svg__paint19_linear_3870_53127)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.06 31.807c-1.15-3.069-1.333-6.313.685-8.33 2.017-2.019 5.262-1.836 8.33-.685 3.198 1.199 6.629 3.566 9.59 6.528 2.963 2.962 5.33 6.393 6.529 9.59 1.15 3.069 1.334 6.313-.684 8.331-2.018 2.018-5.263 1.835-8.331.684-3.198-1.198-6.629-3.566-9.59-6.528-2.963-2.962-5.33-6.393-6.529-9.59zm3.023-5.993c-.566.565-.968 2.056.073 4.832.993 2.648 3.05 5.693 5.77 8.413 2.72 2.721 5.766 4.778 8.414 5.77 2.776 1.042 4.266.64 4.832.074.565-.565.967-2.056-.074-4.832-.993-2.647-3.05-5.693-5.77-8.413-2.72-2.72-5.766-4.778-8.414-5.77-2.776-1.042-4.266-.64-4.831-.074z",
    fill: "url(#tada-icon_svg__paint20_linear_3870_53127)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.177 23.864c.805.43 1.11 1.432.68 2.237L4.22 60.98a2.064 2.064 0 00.359 2.43 2.06 2.06 0 002.428.36l34.879-18.638a1.653 1.653 0 111.558 2.916L8.566 66.686a5.368 5.368 0 01-7.84-3.948 5.366 5.366 0 01.579-3.318L19.94 24.543a1.653 1.653 0 012.237-.679z",
    fill: "url(#tada-icon_svg__paint21_linear_3870_53127)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint0_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint1_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint2_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint3_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint4_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint5_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint6_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint7_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint8_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint9_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint10_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint11_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint12_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint13_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint14_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint15_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint16_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint17_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint18_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint19_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint20_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tada-icon_svg__paint21_linear_3870_53127",
    x1: 34.001,
    y1: 0.653,
    x2: 34.001,
    y2: 67.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E018D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#7212E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C348EA"
  })))));
}
export default __webpack_public_path__ + "static/tada-icon.fc5b9dc9.svg";
export { SvgTadaIcon as ReactComponent };